import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RangeSlider from 'shared/components/RangeSlider';
import AggregationBox from './AggregationBox';
import styles from './AggregationBox.module.scss';

const RangeBox = ({ current, type, formatValueLabel, title, defaultValue, min, max, step, onSelect, onReset }) => {
  const [value, setValue] = useState(defaultValue);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (current !== value) {
      setValue(current);
    }
  }, [current]);

  const formatValue = v => v;

  const onChange = values => setValue(values[0]);

  const onFinalChange = (values) => {
    if (values[0] > min) {
      onSelect(values[0]);
    } else {
      onReset();
    }
  };

  return (
    <AggregationBox title={title}>
      <div className={styles.rangeContent} id={`${type}-box`}>
        <RangeSlider
          min={min}
          max={max}
          step={step}
          values={[value]}
          labels={[value > min ? formatValueLabel(value) : t('slider.notSelected'), formatValue(max)]}
          onChange={onChange}
          onFinalChange={onFinalChange}
        />
      </div>
    </AggregationBox>
  );
};

RangeBox.propTypes = {
  current: PropTypes.number,
  formatValueLabel: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  defaultValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onSelect: PropTypes.func,
  onReset: PropTypes.func
};

RangeBox.defaultProps = {
  current: -1,
  formatValueLabel: v => v,
  title: '',
  type: '',
  defaultValue: 0,
  min: 0,
  max: 0,
  step: 1,
  onSelect() {},
  onReset() {}
};

export default RangeBox;
